import { React, useState, useEffect } from 'react';

import { useRecoilValue } from 'recoil';
import { TransientState } from '../../../storage';

import { Box, Divider, Typography } from '@mui/material';
import { ConfigTable, PillTabs } from '../../';
import { AdminObjectList } from '../../../api';

const LOISE_CONFIG_TABS = [
    { value: 'client', label: 'Client' },
    { value: 'server', label: 'Server' },
];

function LoiseConfig() {
    const [tab, setTab] = useState('client');
    const transient = useRecoilValue(TransientState);

    const configs = tab === 'client' ? transient.loise.client.data : transient.loise.server.data;
    const meta = (tab === 'client' ? transient.loise.client.meta : transient.loise.server.meta) ?? {};
    const currentHash = meta.hash ?? '—';

    useEffect(() => {
        AdminObjectList('loise', 'client');
        AdminObjectList('loise', 'server');
    }, []);

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <PillTabs value={tab} onChange={setTab} tabs={LOISE_CONFIG_TABS} />
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                <ConfigTable
                    service='loise'
                    type={tab}
                    configs={configs}
                    onRefresh={() => AdminObjectList('loise', tab)}
                />
            </Box>
            <Divider />
            <Box sx={{ px: 2, py: 0.5 }}>
                <Typography variant='caption' color='text.secondary'>
                    hash: {currentHash}
                </Typography>
            </Box>
        </Box>
    );
}

export { LoiseConfig };
